"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcDataTableFooterBehavior = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var bc_data_table_constants_1 = require("./bc-data-table-constants");
var BcDataTableFooterBehavior = (function () {
    function BcDataTableFooterBehavior(bcDataTableConfig) {
        var _a, _b, _c;
        this.bcDataTableConfig = bcDataTableConfig;
        this.paginatorHeaderConfig = (_a = this.bcDataTableConfig.header) === null || _a === void 0 ? void 0 : _a.paginator;
        this.paginatorFooterConfig = (_b = this.bcDataTableConfig.footer) === null || _b === void 0 ? void 0 : _b.paginator;
        if (this.bcDataTableConfig.footer !== undefined) {
            this.paginatorFooterConfig.align = (_c = this.bcDataTableConfig.footer) === null || _c === void 0 ? void 0 : _c.paginator.align;
        }
    }
    BcDataTableFooterBehavior.prototype.isMobile = function () {
        var regex = bc_data_table_constants_1.BcDataTableConstansts.REGEX_MOBILE;
        var isMobileBrowser = regex.test(navigator.userAgent);
        var hasMinimumSize = (window.innerWidth <= bc_data_table_constants_1.BcDataTableConstansts.MOBILE_BROWSER_MIN_WIDTH) && (window.innerHeight <= bc_data_table_constants_1.BcDataTableConstansts.MOBILE_BROWSER_MIN_HEIGHT);
        return (isMobileBrowser || hasMinimumSize);
    };
    BcDataTableFooterBehavior.prototype.setFooter = function (dataTable) {
        var footerDiv = this.createFooterDiv();
        var flexContainer = this.createFlexContainer();
        var paginatorDiv = this.createPaginatorDiv();
        flexContainer.appendChild(paginatorDiv);
        footerDiv.appendChild(flexContainer);
        dataTable.insertAdjacentElement(common_constants_1.BcCommonConstants.AFTER_END, footerDiv);
    };
    BcDataTableFooterBehavior.prototype.createFooterDiv = function () {
        var footerDiv = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        footerDiv.classList.add(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_FOOTER_CONTAINER);
        return footerDiv;
    };
    BcDataTableFooterBehavior.prototype.createFlexContainer = function () {
        var _a, _b;
        var flexContainer = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        flexContainer.classList.add(bc_data_table_constants_1.BcDataTableConstansts.FLEX_CLASS, bc_data_table_constants_1.BcDataTableConstansts.ROW_BORDER_CLASS);
        if (this.isMobile()) {
            flexContainer.classList.add(bc_data_table_constants_1.BcDataTableConstansts.JUSTIFY_CONTENT_SPACE_XS_CENTER);
        }
        else {
            flexContainer.classList.add(((_a = this.paginatorFooterConfig) === null || _a === void 0 ? void 0 : _a.align) === 'left'
                ? bc_data_table_constants_1.BcDataTableConstansts.JUSTIFY_CONTENT_SPACE_BETWEEN_CLASS
                : ((_b = this.paginatorFooterConfig) === null || _b === void 0 ? void 0 : _b.align) === 'center'
                    ? bc_data_table_constants_1.BcDataTableConstansts.JUSTIFY_CONTENT_SPACE_XS_CENTER
                    : bc_data_table_constants_1.BcDataTableConstansts.JUSTIFY_CONTENT_SPACE_FLEX_END);
        }
        return flexContainer;
    };
    BcDataTableFooterBehavior.prototype.createPaginatorDiv = function () {
        var paginatorDiv = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        paginatorDiv.classList.add(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_FOOTER_PAGINATOR_CLASS);
        paginatorDiv.classList.add(this.paginatorHeaderConfig.classToSync);
        return paginatorDiv;
    };
    return BcDataTableFooterBehavior;
}());
exports.BcDataTableFooterBehavior = BcDataTableFooterBehavior;
